import React, { useState } from 'react';
import { Link, NavLink, useNavigate, useParams } from 'react-router-dom';

import Radio from "./radio/Radio";

const resources = [
	{
		id: "listen-live",
		title: "Listen Live",
		type: "iframe",
		content: (
			<iframe
				title="Listen Live"
				width="450" height="316"
				frameBorder="0"
				src="https://live365.com/embeds/v1/played/a96984?s=md&m=dark"
			/>
		),
		link: "/radios/listen-live",
	},
	{
		id: "last-played",
		title: "Last Played Songs",
		type: "iframe",
		content: (
			<iframe
				title="Last Played Songs"
				width="450" height="511"
				frameBorder="0"
				src="https://live365.com/embeds/v1/player/a96984?s=md&m=dark&c=mp3"
			/>
		),
		link: "/radios/last-played",
	},
];

const Radios = () => {

	const listenLiveResource = resources.find(r => r.id === 'listen-live');
	const lastPlayedResource = resources.find(r => r.id === 'last-played');

	const [showLastPlayed, setShowLastPlayed] = useState(false);

	return (
		<div className="body-content bg-fff pt-80l-70m-60s pb-120">

			<div className="panel large ptb-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-libre-baskerville font-size-24l-20m-16s font-weight-800 bb1-555 pb-5">Radio</div>
					</div>
				</div>
			</div>

			{listenLiveResource &&
				<div className="panel large">
					<div className="grid-x pt-20l-10s">
						<div className="large-12 medium-12 small-12 cell text-center">
							<div className="large-12 medium-12 small-12 cell text-center">
								<div className="font-raleway font-size-24l-20m-18s font-weight-600 txt-000 text-center line-height-125per">
									{listenLiveResource.title}
								</div>
								<Radio resourceId={listenLiveResource.id} />
							</div>

						</div>
					</div>
				</div>
			}

			<div className="episode-description-toggle hover-opacity-50 font-raleway font-size-24l-20m-18s font-weight-600 txt-000 align-center line-height-125per pt-30"

				onClick={() =>
					setShowLastPlayed(previous => !previous)
				}
			>

				<span>Last Played Songs</span>

				<span className="episode-chevron pl-5">
					{showLastPlayed
						? "▲"
						: "▼"
					}
				</span>
			</div>

			{lastPlayedResource && showLastPlayed &&
				<div className="panel large">
					<div className="grid-x">
						<div className="large-12 medium-12 small-12 cell text-center">
							<Radio resourceId={lastPlayedResource.id} />
						</div>
					</div>
				</div>
			}
		</div>
	);
}

export default Radios;